<template>
    <v-dialog v-model="enable" ref="dialogEditor" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card ref="cardEditor" @mouseup="onMouseUp">
        <v-toolbar dark color="primary">
          <v-toolbar-items>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="drawer || image.Locked" @click="onRotate('l')" v-on="on" text>
                  <v-icon>mdi-rotate-left</v-icon>
                </v-btn>
              </template>
              <span>{{$t('editor.rotateleft')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="drawer || image.Locked" @click="onRotate('r')" v-on="on" text>
                  <v-icon>mdi-rotate-right</v-icon>
                </v-btn>
              </template>
              <span>{{$t('editor.rotateright')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="isDisabled" active-class="highlighted" :class="(activeTool === 'REDUCT') ? 'highlighted' : ''" @click="onEnableDraw(false, false)" v-on="on" text>
                  <v-icon>mdi-draw</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('editor.tooltip_draw') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="isDisabled" active-class="highlighted" :class="(activeTool === 'CROP') ? 'highlighted' : ''" @click="onEnableDraw(true, false)" v-on="on" text>
                  <v-icon>mdi-crop</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('editor.tooltip_crop') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="isDisabled" active-class="highlighted" :class="(activeTool === 'CREATE_DOC') ? 'highlighted' : ''" @click="onEnableDraw(false, true)" v-on="on" text>
                  <v-icon>mdi-file-multiple</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('editor.tooltip_createDoc') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-show="changes > 0" @click="onSave(false)" v-on="on" text>
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('editor.changes_save') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-show="changes > 0 || drawer || crop || createDoc" @click="onCancelChanges(false)" v-on="on" text>
                  <v-icon>mdi-card-remove</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('editor.changes_cancel') }}</span>
            </v-tooltip>
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-btn icon dark @click="closeMainDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container style="margin-left: 0; margin-right: 0; max-width: 100% !important;">
            <splitpanes @resize="onResizePane" @resized="onResizedPane" class="default-theme">
              <pane min-size="20">
                <v-container id="idContainer" v-scroll.self="onScroll" class="overflow-y-auto" style="margin: 0; max-height: calc(100vh - 90px);">
                  <v-row>
                    <v-col :cols="12">
                      <v-card-title class="title" style="color: black !important;">{{ (images.indexOf(image) + 1) }}</v-card-title>
                      <v-img :src="(image === null) ? '' : (image.Base64Full === '') ? image.Base64 : image.Base64Full" height="auto" class="grey darken-4" ref="img" @mousedown="onMouseDown" @mouseup="onMouseUp" @mousemove="onMouseMove">
                        <Region v-for="field in Fields" :batchTypes="batchTypes" :field="field" :image="image" :crop="crop" :createDoc="createDoc" :key="field.Id"></Region>
                      </v-img>
                    </v-col>
                  </v-row>
                </v-container>
              </pane>
              <pane min-size="20">
                <v-container v-scroll.self="onScroll" class="overflow-y-auto" style="margin: 0; max-height: calc(100vh - 90px);">
                  <v-row>
                    <v-col v-for="img in images" :key="img.Name" :cols="2" >
                      <v-card @click="clickFile(img)" :outlined="img === image" :elevation="(img === image) ? 5 : 1"  :color="(img === image) ? 'primary' : '#fff'" :disabled="(img.ReqId > 0) ? true : false" :loading="(img.Load) ? cardLoadingColor : false">
                        <div class="selecti" v-show="img.Selected"></div>
                        <v-img :src="img.Base64" contain height="auto"></v-img>
                        <v-card-title tag="span" class="ctitle">{{ (images.indexOf(img) + 1) }}</v-card-title>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </pane>
            </splitpanes>
        </v-container>
      </v-card>
      <v-dialog v-model="saveDialog" persistent width="65%">
        <v-card>
          <v-card-title>Edit</v-card-title>
          <v-card-title class="headline"></v-card-title>
          <v-card-text>{{ $t("editor.changes") }}</v-card-text>
          <v-card-actions>
            <v-btn text @click="saveDialog = false">{{ $t("editor.changes_cancel") }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn text v-show="onlySave === true" @click="onSave(false)" color="green">{{ $t("editor.changes_save") }}</v-btn>
            <v-btn text v-show="onlySave === true" @click="onCancelChanges(false)" color="red">{{ $t("editor.changes_cancel") }}</v-btn>
            <v-btn text v-show="onlySave === false" @click="onSave(true)" color="green">{{ $t("editor.changes_discard_save") }}</v-btn>
            <v-btn text v-show="onlySave === false" @click="onCancelChanges(true)" color="red">{{ $t("editor.changes_discard_close") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
</template>

<script>
import Models from '@/Models'
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import Region from '@/components/Region'

export default {
  components: { Splitpanes, Pane, Region },
  name: 'ImageEditor',
  props: ['editdata', 'batchTypes'],
  data () {
    return {
      onlySave: false,
      saveDialog: false,
      isMouseDown: false,
      isMouseUp: true,
      img: null,
      mouseClientX: 0,
      mouseClientY: 0,
      contextClientX: 0,
      contextClientY: 0,
      isDrawing: false,
      ctrlDown: false,
      rotating: false,
      title: '',
      enable: false,
      image: null,
      nextImage: null,
      images: [],
      naturalWidth: 0,
      naturalHeight: 0,
      clientWidth: 0,
      clientHeight: 0,
      currentTarget: null,
      currentField: null,
      drawer: false,
      crop: false,
      createDoc: false,
      changes: 0,
      activeTool: ''
    }
  },
  computed: {
    Fields () {
      if (this.image === null) return []
      return this.image.Fields
    },
    isDisabled () {
      if (this.image.Locked) return true
      if (this.drawer || this.crop || this.createDoc) return true
      return false
    }
  },
  methods: {
    onScroll (ev) {
      console.log('onScroll card', ev)
    },
    closeMainDialog () {
      if (this.changes > 0) {
        this.saveDialog = true
      } else {
        this.changes = 0
        this.drawer = false
        this.enable = false
      }
    },
    onCancelChanges (closeDialog = false) {
      if (this.image !== null) {
        this.image.Fields = []
      }
      this.changes = 0
      this.drawer = this.crop = this.createDoc = false
      this.activeTool = ''
      if (this.nextImage !== null) {
        this.image = this.nextImage
        this.$emit('loadFullSource', this.nextImage)
        this.nextImage = false
        this.onlySave = false
        this.saveDialog = false
      }
      if (closeDialog) {
        this.saveDialog = false
        this.enable = false
      }
    },
    onResizedPane (ev) {
      this.sendResize()
    },
    onResizePane (ev) {
      // console.log(this.$refs.img)
      this.sendResize()
    },
    sendResize () {
      this.clientWidth = this.$refs.img.$el.clientWidth
      this.clientHeight = this.$refs.img.$el.clientHeight
      this.$root.$emit('EDIT_RESIZE', { clientWidth: this.clientWidth, clientHeight: this.clientHeight })
    },
    onEnableDraw (crop = false, createDoc = false) {
      this.drawer = !this.drawer
      this.crop = (crop && this.crop) ? false : crop
      this.createDoc = (createDoc && this.createDoc) ? false : createDoc
      this.activeTool = ''
      if (this.drawer) this.activeTool = 'REDUCT'
      if (this.crop) this.activeTool = 'CROP'
      if (this.createDoc) this.activeTool = 'CREATE_DOC'
    },
    onSave (closeDialog = false) {
      console.log('save image')
      this.drawer = true
      this.$emit('onedit', null, this.image, this.activeTool)
      this.crop = this.createDoc = false
      this.activeTool = ''
      if (this.nextImage !== null) {
        this.image = this.nextImage
        this.$emit('loadFullSource', this.nextImage)
        this.nextImage = false
        this.onlySave = false
        this.saveDialog = false
      }
      if (closeDialog) {
        this.saveDialog = false
        this.enable = false
      }
    },
    clickFile (img) {
      console.log('clickFile', img, img.Name)
      if (this.changes > 0) {
        this.saveDialog = true
        this.onlySave = true
        this.nextImage = img
      } else {
        const i = this.image
        this.image = img
        this.$emit('loadFullSource', img)
        if (i !== null && i !== undefined) i.Base64Full = ''
      }
    },
    onRotate (type) {
      if (this.rotating) return
      console.log('onRotate', type)
      const imgtr = Models.ImgTransform
      imgtr.RotationType = (type === 'l') ? imgtr.ROTATE_LEFT : imgtr.ROTATE_RIGHT
      imgtr.Rotation = 90
      this.drawer = true
      this.$emit('onedit', imgtr, this.image, imgtr.RotationType)
      this.rotating = true
      window.setTimeout(() => {
        this.rotating = false
      }, 500)
    },
    onMouseDown (ev) {
      if (this.isContextOpen || this.image === null) return
      if (!ev.target.classList.contains('v-responsive__content') || ev.which !== 1 || ev.target.classList.contains('vdr-stick') || ev.target.classList.contains('vdr')) return
      if (this.image.Fields.length > 0 && this.crop === true) return
      this.isMouseDown = true
      this.naturalWidth = this.$refs.img.image.naturalWidth
      this.naturalHeight = this.$refs.img.image.naturalHeight
      this.clientWidth = this.$refs.img.$el.clientWidth
      this.clientHeight = this.$refs.img.$el.clientHeight
      this.contextClientX = ev.clientX
      this.contextClientY = ev.clientY
      // console.log(ev.pageX, ev.pageY, ev.clientX, ev.clientY, ev.currentTarget.offsetLeft, ev.currentTarget.offsetTop, ev.currentTarget.getBoundingClientRect().left, ev.currentTarget.getBoundingClientRect().top)
      this.mouseClientX = ev.pageX - ev.currentTarget.offsetLeft // ev.currentTarget.offsetLeft // ev.target.getBoundingClientRect().left
      // const topCard = Math.abs(this.$refs.cardEditor.$el.getBoundingClientRect().top)
      // const topCard = Math.abs(window.document.getElementById('idContainer').getBoundingClientRect().top)
      // let topCard = window.document.getElementById('idContainer').getBoundingClientRect().top
      const topCard = window.document.getElementById('idContainer').scrollTop
      /* if (topCard < 0) {
        topCard = Math.abs(topCard)
      } else {
        topCard = 0
      } */
      this.mouseClientY = ev.pageY - ev.currentTarget.offsetTop + topCard // ev.currentTarget.offsetTop // ev.target.getBoundingClientRect().top
      this.currentTarget = ev.currentTarget
      console.log('mouse down clientxy:', this.mouseClientX, this.mouseClientY, this.$refs.cardEditor.$el.getBoundingClientRect(), window.document.getElementById('idContainer').scrollTop)
      return false
    },
    getScrollPosition (el = window) {
      return el.pageYOffset !== undefined ? el.pageYOffset : el.scrollTop
    },
    onMouseMove (ev) {
      if (this.isMouseDown === true && this.drawer === true) {
        if (this.selectedField !== null) {
          // const topCard = Math.abs(this.$refs.cardEditor.$el.getBoundingClientRect().top)
          // const topCard = Math.abs(window.document.getElementById('idContainer').getBoundingClientRect().top)
          // let topCard = window.document.getElementById('idContainer').getBoundingClientRect().top
          const topCard = window.document.getElementById('idContainer').scrollTop
          /* if (topCard < 0) {
            topCard = Math.abs(topCard)
          } else {
            topCard = 0
          } */
          const clientX = ev.pageX - this.currentTarget.offsetLeft // ev.currentTarget.getBoundingClientRect().left // $(ev.currentTarget).offset().left;
          const clientY = ev.pageY - this.currentTarget.offsetTop // ev.currentTarget.getBoundingClientRect().top // $(ev.currentTarget).offset().top;
          console.log(clientY, topCard, this.mouseClientY, clientY - this.mouseClientY)
          const w = clientX - this.mouseClientX
          const h = (clientY + topCard) - this.mouseClientY
          // console.log('mouse move client xywh:', this.mouseClientX, this.mouseClientY, w, h)
          if (Math.abs(w) > 7 || Math.abs(h) > 7) {
            if (this.currentField === null) {
              const field = Models.Field
              field.region = Models.Region
              field.region.rgba = this.batchTypes.General.rgba
              field.region.x = this.mouseClientX
              field.region.y = this.mouseClientY
              field.region.w = w
              field.region.h = h
              field.region.naturalWidth = this.naturalWidth
              field.region.naturalHeight = this.naturalHeight
              field.naturalWidth = this.naturalWidth
              field.naturalHeight = this.naturalHeight
              field.region.clientWidth = this.clientWidth
              field.region.clientHeight = this.clientHeight
              field.clientWidth = this.clientWidth
              field.clientHeight = this.clientHeight
              if (this.crop) field.crop = true
              if (this.createDoc) field.createDoc = true
              this.$store.state.selectedField = field
              this.image.Fields.push(field)
              this.currentField = field
              this.image.Fields.forEach(f => {
                f.selected = false
              })
              this.currentField.selected = true
              this.changes++
            } else {
              const field = this.currentField
              field.region.x = this.mouseClientX
              field.region.y = this.mouseClientY
              field.region.w = w
              field.region.h = h
            }
          }
        }
      }
    },
    onMouseUp (ev) {
      console.log('onMouseUp', ev.currentTarget)
      this.isMouseDown = false
      this.isMouseUp = true
      this.currentField = null
      return false
    }
  },
  watch: {
    enable: function (val) {
      this.enable = val
      console.log('IMAGE EDITO:', this.image)
      if (this.enable) {
        this.clickFile(this.image)
        window.setTimeout(() => {
          this.sendResize()
        }, 1000)
      }
    },
    'image.Base64Full': function (newVal) {
      console.log('Base64Full changed!!')
      this.changes = 0
      this.drawer = false
      this.image.Fields = []
      this.$forceUpdate()
      this.$emit('loadFullSource', this.image)
    }
  }
}
</script>

<style scoped>
.ctitle {
  background-color: rgba(255, 255, 255, .3);
  font-size: 10px !important;
  font-weight: bold;
  margin: 0 !important;
  padding: 0 !important;
  text-align: center !important;
  line-height: inherit !important;
  padding-left: 45% !important;
}
.highlighted {
  background-color: rgba(255, 255, 255, .5);
}

.splitpanes__pane {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Helvetica, Arial, sans-serif;
  color: rgba(0, 255, 255, 0.6);
  font-size: 5em;
}
</style>
